import PropTypes from 'prop-types';

export default PropTypes.arrayOf(
  PropTypes.shape({
    type: PropTypes.string,
    totalAmountInPounds: PropTypes.number,
    totalAmountInEuros: PropTypes.number,
    totalAmountInDollars: PropTypes.number
  })
);
